module.exports = __webpack_public_path__ + "media/images/mobile/logo/avatar-f32389fbc801e800417e4c533d85615a.png";